<template>
    <v-card class="chart-card pa-0" height="100%">
        <div v-if="cleanTitle" class="chart-card-title" :title="cleanTitle">{{ cleanTitle }}</div>
        <v-card-text class="text-center chart-card-body">
            <p v-if="pieOptions.labels.includes('Promoters') || pieOptions.labels.includes('المنتقدون')" class="responsive-p">{{this.series[0]-this.series[2]}}</p>
            <apexchart ref="apex" :height="height" type="donut" :options="pieOptions" :series="pieOptions.series" />
            <div class="chart-legend">
                <div v-for="(label, i) in labels" :key="i" class="chart-legend-item">
                    <span class="chart-legend-color" :style="{ backgroundColor: colors[i % colors.length] }"></span>
                    <span class="chart-legend-label">{{ label }}</span>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import apexchart from 'vue-apexcharts'
    import { captureWithLegend, COLORS } from './chartExportUtils'

    export default {

        components: {
            apexchart
        },

        props: ['title', 'height', 'series', 'labels'],

        data() {
            return {
                colors: COLORS,
                pieOptions: {
                    series: this.series,
                    colors: COLORS,
                    labels: this.labels,
                    title: {
                        text: ''
                    },
                    chart: {
                        type: 'donut',
                        fontFamily: 'Tajawal',
                        toolbar: {
                            show: false,
                        }
                    },
                    xaxis: {
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%'
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val, opts) {
                            const percentage = val.toFixed(0) + '%'
                            const number = opts.w.config.series[opts.seriesIndex]
                            return [percentage, number]
                        },
                        style: {
                            fontSize: '9px',
                            fontWeight: ''
                        },
                        offsetX: 0,
                        horizontal: true
                    },
                    responsive: [{
                        breakpoint: 300,
                        options: {
                            chart: {},
                            legend: {
                                show: false
                            }
                        }
                    }],
                    legend: {
                        show: false
                    }
                },
                pieSeries: [],
            }
        },
        computed: {
            cleanTitle() {
                return (this.title || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
            }
        },
        watch: {
            series: {
                handler(newSeries) {
                    this.$set(this.pieOptions, 'series', newSeries)
                },
                immediate: true
            },
            labels: {
                handler(newLabels) {
                    this.pieOptions = {
                        ...this.pieOptions,
                        labels: newLabels
                    }
                },
                immediate: true
            }
        },

        methods: {
            async capture() {
                try {
                    return await captureWithLegend(this.$refs.apex, this.labels || [])
                } catch (e) {
                    console.error('Doghnut capture failed', e)
                    return null
                }
            }
        }
    }
</script>

<style>
    .apexcharts-toolbar {
        top: -17px !important;
        right: -20px !important;
    }

    /* Shared chart-card design (Doghnut / Bar / Line) */
    .chart-card {
        border: 1px solid #e0e6e3 !important;
        border-radius: 10px !important;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        transition: box-shadow .2s ease;
        box-shadow: 0 1px 3px rgba(0, 0, 0, .06) !important;
    }

    .chart-card:hover {
        box-shadow: 0 4px 16px rgba(27, 110, 83, .18) !important;
    }

    .chart-card-title {
        background: #eef4f1;
        color: #1b6e53;
        font-family: 'Tajawal', sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 1.5;
        padding: 10px 14px;
        border-bottom: 2px solid #1b6e53;
        min-height: 54px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        flex-shrink: 0;
    }

    .chart-card-body {
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    /* جدول tab: same card look for the per-question tables */
    .table-question-card {
        background: #fff;
        height: 100%;
    }

    .responsive-p {
        position: absolute;
        font-size: 25px;
        color: red;
        font-weight: bold;
        top: calc(50% - 18px);
        right: calc(50% - 14px);
    }

    .chart-legend {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 8px 16px;
        margin-top: 8px;
        padding: 0 8px 4px;
    }

    .chart-legend-item {
        display: flex;
        align-items: center;
        gap: 5px;
        font-family: 'Tajawal', sans-serif;
        font-size: 12px;
        color: #263238;
    }

    .chart-legend-color {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 2px;
        flex-shrink: 0;
    }

    .chart-legend-label {
        white-space: nowrap;
    }

    @media screen and (max-width: 768px) {
        .responsive-p {
            font-size: 18px;
            top: calc(50% - 40px);
            right: calc(50% - 10px);
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1044px) {
        .responsive-p {
            font-size: 20px;
            top: calc(50% - 37px);
            right: calc(50% - 11px);
        }
    }
</style>
